export default class RealizedGlDefinitions {
  static getDefault = () =>
    new RealizedGlDefinitions({
      realizedGlMTD: false,
      realizedGlQTD: false,
      realizedGlYTD: false,
      perRealizedGlMTD: false,
      perRealizedGlQTD: false,
      perRealizedGlYTD: false,
      roiYTD: false,
    });
  #realizedGlMTD;
  #realizedGlQTD;
  #realizedGlYTD;
  #perRealizedGlMTD;
  #perRealizedGlQTD;
  #perRealizedGlYTD;
  #roiYTD;

  constructor(props = {}) {
    const {
      realizedGlMTD,
      realizedGlQTD,
      realizedGlYTD,
      perRealizedGlMTD,
      perRealizedGlQTD,
      perRealizedGlYTD,
      roiYTD,
    } = props;
    this.#realizedGlMTD = realizedGlMTD ?? false;
    this.#realizedGlQTD = realizedGlQTD ?? false;
    this.#realizedGlYTD = realizedGlYTD ?? false;
    this.#perRealizedGlMTD = perRealizedGlMTD ?? false;
    this.#perRealizedGlQTD = perRealizedGlQTD ?? false;
    this.#perRealizedGlYTD = perRealizedGlYTD ?? false;
    this.#roiYTD = roiYTD ?? false;
  }

  get realizedGlMTD() {
    return this.#realizedGlMTD;
  }

  get realizedGlQTD() {
    return this.#realizedGlQTD;
  }

  get realizedGlYTD() {
    return this.#realizedGlYTD;
  }
  get perRealizedGlMTD() {
    return this.#perRealizedGlMTD;
  }

  get perRealizedGlQTD() {
    return this.#perRealizedGlQTD;
  }

  get perRealizedGlYTD() {
    return this.#perRealizedGlYTD;
  }

  get roiYTD() {
    return this.#roiYTD;
  }

  setRealizedGlMTD = (value) =>
    new RealizedGlDefinitions({
      realizedGlMTD: value,
      realizedGlQTD: this.#realizedGlQTD,
      realizedGlYTD: this.#realizedGlYTD,
      perRealizedGlMTD: this.#perRealizedGlMTD,
      perRealizedGlQTD: this.#perRealizedGlQTD,
      perRealizedGlYTD: this.#perRealizedGlYTD,
      roiYTD: this.#roiYTD,
    });

  setRealizedGlQTD = (value) =>
    new RealizedGlDefinitions({
      realizedGlMTD: this.#realizedGlMTD,
      realizedGlQTD: value,
      realizedGlYTD: this.#realizedGlYTD,
      perRealizedGlMTD: this.#perRealizedGlMTD,
      perRealizedGlQTD: this.#perRealizedGlQTD,
      perRealizedGlYTD: this.#perRealizedGlYTD,
      roiYTD: this.#roiYTD,
    });

  setRealizedGlYTD = (value) =>
    new RealizedGlDefinitions({
      realizedGlMTD: this.#realizedGlMTD,
      realizedGlQTD: this.#realizedGlQTD,
      realizedGlYTD: value,
      perRealizedGlMTD: this.#perRealizedGlMTD,
      perRealizedGlQTD: this.#perRealizedGlQTD,
      perRealizedGlYTD: this.#perRealizedGlYTD,
      roiYTD: this.#roiYTD,
    });

  setPerRealizedGlMTD = (value) =>
    new RealizedGlDefinitions({
      realizedGlMTD: this.#realizedGlMTD,
      realizedGlQTD: this.#realizedGlQTD,
      realizedGlYTD: this.#realizedGlYTD,
      perRealizedGlMTD: value,
      perRealizedGlQTD: this.#perRealizedGlQTD,
      perRealizedGlYTD: this.#perRealizedGlYTD,
      roiYTD: this.#roiYTD,
    });

  setPerRealizedGlQTD = (value) =>
    new RealizedGlDefinitions({
      realizedGlMTD: this.#realizedGlMTD,
      realizedGlQTD: this.#realizedGlQTD,
      realizedGlYTD: this.#realizedGlYTD,
      perRealizedGlMTD: this.#perRealizedGlMTD,
      perRealizedGlQTD: value,
      perRealizedGlYTD: this.#perRealizedGlYTD,
      roiYTD: this.#roiYTD,
    });

  setPerRealizedGlYTD = (value) =>
    new RealizedGlDefinitions({
      realizedGlMTD: this.#realizedGlMTD,
      realizedGlQTD: this.#realizedGlQTD,
      realizedGlYTD: this.#realizedGlYTD,
      perRealizedGlMTD: this.#perRealizedGlMTD,
      perRealizedGlQTD: this.#perRealizedGlQTD,
      perRealizedGlYTD: value,
      roiYTD: this.#roiYTD,
    });

  setRoiYTD = (value) =>
    new RealizedGlDefinitions({
      realizedGlMTD: this.#realizedGlMTD,
      realizedGlQTD: this.#realizedGlQTD,
      realizedGlYTD: this.#realizedGlYTD,
      perRealizedGlMTD: this.#perRealizedGlMTD,
      perRealizedGlQTD: this.#perRealizedGlQTD,
      perRealizedGlYTD: this.#perRealizedGlYTD,
      roiYTD: value,
    });

  get complete() {
    return true;
  }

  get key() {
    return [
      this.#realizedGlMTD,
      this.#realizedGlQTD,
      this.#realizedGlYTD,
      this.#perRealizedGlMTD,
      this.#perRealizedGlQTD,
      this.#perRealizedGlYTD,
      this.#roiYTD,
    ].join(",");
  }

  copy = () => {
    return {
      realizedGlMTD: this.realizedGlMTD,
      realizedGlQTD: this.realizedGlQTD,
      realizedGlYTD: this.realizedGlYTD,
      perRealizedGlMTD: this.perRealizedGlMTD,
      perRealizedGlQTD: this.perRealizedGlQTD,
      perRealizedGlYTD: this.perRealizedGlYTD,
      roiYTD: this.roiYTD,
    };
  };
}
